module.exports = __webpack_public_path__ + "img/baner4.01b6eef7.png";